import { Rate, Tooltip } from 'antd';
import React from 'react';
import withStyles from 'react-jss';
import { StylesProps } from 'src/Library/Types';
import TextNoWrap from '../TextNoWrap';

interface PropType extends StylesProps<ReturnType<typeof styles>> {
  tooltips: string[];
  onChange?: (data?: any) => void;
  value: any;
  disabled: boolean;
  styles?: any;
  isView?: boolean;
  isFlex?: boolean;
  ratingViewLabel?: string;
  labelStyles?: any;
  maxChars?: number;
}

const styles = () => ({
  rateColor: {
    color: '#EC9632 !important',
  },
  rateContainerColumn: {
    display: 'grid',
    alignItems: 'center',
    rowGap: '5px',
    justifyItems: 'center',
  },
  rateContainerRow: {
    display: 'flex',
    alignItems: 'center',
    columnGap: '5px',
    justifyItems: 'center',
  },
});

const FieldRate: React.FC<PropType> = ({
  classes,
  tooltips,
  onChange,
  value,
  isView,
  styles,
  isFlex,
  ratingViewLabel,
  labelStyles,
  maxChars = 13,
  ...props
}) => {
  return (
    <div
      className={isFlex ? classes.rateContainerRow : classes.rateContainerColumn}
      style={{ justifyItems: isView ? 'center' : 'left' }}
    >
      <Rate
        className={classes.rateColor}
        tooltips={tooltips}
        onChange={onChange}
        value={value}
        style={styles}
        {...props}
      />
      {isView && ratingViewLabel ? (
          <TextNoWrap value={ratingViewLabel} maxChars={maxChars} placement='topLeft' style={labelStyles}/>
      ) : null}
    </div>
  );
};

export default withStyles(styles)(FieldRate);
